import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { color } from '../../templates/Ui';
const StyledLabel = styled.label `
    display: block;
    color: ${color.error.base};
    font-size: 14px;
    font-weight: 600;
    margin-top: 5px;
`;
const ErrorLabel = ({ children }) => (_jsx(StyledLabel, { children: children }));
export default ErrorLabel;
